(function () {
  function initIndexBlogSlider(section) {
    if (!section || typeof Swiper === 'undefined') return;

    var slider = section.querySelector('.index-blog-slider__swiper');
    if (!slider) return;

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    var desktopSlides = parseInt(section.dataset.slidesPerView, 10) || 3;
    var nextButton = section.querySelector('.next-button');
    var prevButton = section.querySelector('.prev-button');
    var scrollbar = section.querySelector('.swiper-scrollbar');
    var swiperOptions = {
      slidesPerView: 1.1,
      spaceBetween: 16,
      speed: 800,
      watchOverflow: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 18
        },
        1024: {
          slidesPerView: desktopSlides,
          spaceBetween: 24
        }
      }
    };

    if (nextButton && prevButton) {
      swiperOptions.navigation = {
        nextEl: nextButton,
        prevEl: prevButton
      };
    }

    if (scrollbar) {
      swiperOptions.scrollbar = {
        el: scrollbar,
        draggable: true,
        hide: false
      };
    }

    new Swiper(slider, swiperOptions);
  }

  function initAllIndexBlogSliders(root) {
    var scope = root || document;
    scope.querySelectorAll('.index-blog-slider').forEach(initIndexBlogSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllIndexBlogSliders();
    });
  } else {
    initAllIndexBlogSliders();
  }

  if (!window.indexBlogSliderSectionLoadBound) {
    window.indexBlogSliderSectionLoadBound = true;
    document.addEventListener('shopify:section:load', function (event) {
      initAllIndexBlogSliders(event.target);
    });
  }
})();
